import type { ComplianceStatus } from '@/components/workbench/ComplianceDecorationPlugin'

export interface EvidenceSource {
  sourceId: string
  source: string
  page: number
  snippet: string
  /** AI-generated semantic bridge explaining why this source matches the claim */
  explanation?: string
}

export interface EvidenceEntry {
  status: ComplianceStatus
  text: string
  sources: EvidenceSource[]
}

export const mockEvidence: Record<string, EvidenceEntry> = {}

/** Vancouver-style references keyed by sourceId */
export const mockReferences: Record<string, string> = {}

/** Abbreviations found in the document */
export const mockAbbreviations: { abbr: string; full: string }[] = []
